import { focusScrollTarget, scrollBehavior } from './scroll_behavior';

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    // Récupère l'ID de la cible depuis l'attribut href
    const targetId = this.getAttribute('href').slice(1);
    const targetElement = document.getElementById(targetId);

    // Sans cible, laisser le navigateur gérer le lien
    if (!targetElement) return;

    e.preventDefault(); // Empêche le comportement par défaut

    // Calcule la position de défilement en fonction de la hauteur du header fixe
    const headerHeight = document.querySelector('header')?.offsetHeight || 0; // Défaut à 0 si aucun header trouvé
    const targetPosition =
      targetElement.getBoundingClientRect().top + window.scrollY; // Position absolue de l'élément
    const scrollToPosition = targetPosition - headerHeight; // Ajuste pour éviter que le header masque

    // Scroll vers la position calculée
    window.scrollTo({
      top: scrollToPosition,
      behavior: scrollBehavior(),
    });

    focusScrollTarget(targetElement);
  });
});
